import React from 'react';

import styled from 'styled-components';

export const CalendarButtons = styled.div`
  display: flex;
  justify-content: center;
  margin-top: auto;
  padding: 8px 4px;
`;

export const CalendarButton = styled.div<{ active: boolean }>`
  padding: 4px 8px;
  background: ${({ active }) => (active ? 'var(--colorBlueGray100)' : 'var(--colorWhite)')};
  border: 1px solid var(--colorBlueGray100);
  border-radius: 4px;
  font-weight: 600;
  font-size: 12px;
  line-height: 136%;
  text-align: center;
  letter-spacing: 0.024em;
  color: var(--colorUIBlue);
  margin: 0 4px;
  cursor: pointer;
  transition: background-color 0.2s ease-in-out;

  &:hover {
    background-color: var(--colorBlueGray100);
  }
`;

export const CalendarWrapper = styled.div`
  height: 100%;
  background-color: var(--colorWhite);
  border-radius: 4px;
  box-shadow: 0px 1px 0px 0px rgba(0, 0, 0, 0.16), 0px 1px 3px 0px rgba(0, 0, 0, 0.16);
  display: flex;
  flex-flow: column nowrap;

  .react-calendar {
    box-shadow: none;
  }
`;
